module.exports = __webpack_public_path__ + "img/icon05.67857712.png";